module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4 px-2"
  }, [(!_vm.isView && !_vm.isLocalAdmin && _vm.initDone) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "d-inline-flex"
  }, [_c('div', {
    staticClass: "pr-3"
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    on: {
      "click": function($event) {
        _vm.showImportModal = !_vm.showImportModal
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.importCompany))])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isView && !_vm.isLocalAdmin && _vm.initDone) ? _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isView,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.templateName,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTemplateName)); }]
    },
    model: {
      value: (_vm.templateName),
      callback: function($$v) {
        _vm.templateName = $$v
      },
      expression: "templateName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.numberOfPrints,
      "readonly": _vm.isView,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingNoPrints)); }]
    },
    model: {
      value: (_vm.noOfPrints),
      callback: function($$v) {
        _vm.noOfPrints = $$v
      },
      expression: "noOfPrints"
    }
  })], 1), _vm._v(" "), (!_vm.isView && !_vm.isClone) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": Object.keys(_vm.types),
      "label": _vm.$lang.actions.selectPrintTemplateType,
      "readonly": _vm.isView,
      "required": "",
      "loading": _vm.typesLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPrintTemplateType)); }]
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.templates,
      "label": _vm.$lang.actions.selectTemplateImport,
      "item-text": "templateName",
      "item-value": "id",
      "disabled": _vm.templates.length === 0
    },
    model: {
      value: (_vm.templateId),
      callback: function($$v) {
        _vm.templateId = $$v
      },
      expression: "templateId"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3 my-0",
    attrs: {
      "disabled": _vm.templateId === null
    },
    on: {
      "click": _vm.populate
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.populate))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'mainaway') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.mainawayTemplate,
      "items": _vm.mainaway,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingMainaway)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'unpaidbill') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.unpaidBillTemplate,
      "items": _vm.unpaidBill,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingUnpaidBill)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'invoice') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.itemTemplate,
      "items": _vm.item,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingItemTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.type === 'invoice') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.taxTemplate,
      "items": _vm.tax,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingTaxTemplate)); }]
    },
    model: {
      value: (_vm.taxContent),
      callback: function($$v) {
        _vm.taxContent = $$v
      },
      expression: "taxContent"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.type === 'label') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.labelTemplate,
      "items": _vm.label,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingLabelTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'kitchen') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.kitchenTemplate,
      "items": _vm.kitchen,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingKitchenTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'driver') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.driverTemplate,
      "items": _vm.driver,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingDriverTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-4 mb-2",
    attrs: {
      "disabled": _vm.editPrefix
    },
    on: {
      "click": _vm.addPrefix
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.prefixLines))]) : _vm._e(), _vm._v(" "), (_vm.isView && _vm.prefixLines.length !== 0) ? _c('h3', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.prefixLines) + ":")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.prefixLines), function(prefix, index) {
    return _c('tr', {
      key: index
    }, [(prefix.isEdit) ? [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPrefix.content !== 'image') ? _c('v-text-field', {
      staticClass: "min-w",
      attrs: {
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPrefix.content),
        "label": _vm.$lang.labels.fontHeight,
        "min": "0",
        "type": "number",
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPrefix.fontHeight),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "fontHeight", $$v)
        },
        expression: "tempPrefix.fontHeight"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPrefix.content !== 'image') ? _c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.fontStyles,
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPrefix.content),
        "label": _vm.$lang.labels.fontStyle,
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPrefix.fontStyle),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "fontStyle", $$v)
        },
        expression: "tempPrefix.fontStyle"
      }
    }) : [_c('v-text-field', {
      ref: "fileTextField",
      refInFor: true,
      staticClass: "min-w",
      attrs: {
        "label": "choose_file",
        "prepend-icon": "attach_file",
        "single-line": "",
        "hide-details": "",
        "required": ""
      },
      on: {
        "click": function($event) {
          return _vm.startInput('prefixFileInput')
        }
      },
      model: {
        value: (_vm.tempPrefix.filename),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "filename", $$v)
        },
        expression: "tempPrefix.filename"
      }
    }), _vm._v(" "), _c('input', {
      ref: "prefixFileInput",
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange('tempPrefix', $event)
        }
      }
    })]], 2), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [_c('v-combobox', {
      staticClass: "min-w",
      attrs: {
        "label": _vm.$lang.labels.content,
        "items": _vm.lineChoices,
        "search-input": _vm.tempPrefix.content,
        "required": "",
        "hide-details": ""
      },
      on: {
        "update:searchInput": function($event) {
          return _vm.$set(_vm.tempPrefix, "content", $event)
        },
        "update:search-input": function($event) {
          return _vm.$set(_vm.tempPrefix, "content", $event)
        }
      },
      model: {
        value: (_vm.tempPrefix.content),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "content", $$v)
        },
        expression: "tempPrefix.content"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempPrefix.content ||
          (_vm.tempPrefix.content !== 'image' && (!_vm.tempPrefix.fontHeight || !_vm.tempPrefix.fontStyle)) ||
          (_vm.tempPrefix.content === 'image' && !_vm.tempPrefix.filename)
      },
      on: {
        "click": function($event) {
          return _vm.savePrefixEdit(prefix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closePrefixEdit(prefix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }, [(_vm.prefixLines.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.prefixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up")]) : _vm._e(), _vm._v(" "), (index != _vm.prefixLines.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.prefixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (prefix.content !== 'image') ? _c('td', [_vm._v(_vm._s(prefix.fontHeight))]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": prefix.content !== 'image' ? 1 : 2
      }
    }, [_vm._v(_vm._s(prefix.content !== 'image' ? prefix.fontStyle : prefix.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prefix.content))]), _vm._v(" "), (!_vm.isView) ? _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": _vm.disablePrefixes
      },
      on: {
        "click": function($event) {
          return _vm.editingPrefix(prefix)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$lang.actions.edit) + "\n                    ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deletePrefix(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1) : _vm._e()]], 2)
  }), 0)])])]), _vm._v(" "), (!_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-4 mt-4 mb-2",
    attrs: {
      "disabled": _vm.editPostfix
    },
    on: {
      "click": _vm.addPostfix
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.postfixLines))]) : _vm._e(), _vm._v(" "), (_vm.isView && _vm.postfixLines.length !== 0) ? _c('h3', {
    staticClass: "mt-4 mx-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.postixLines) + ":")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.postfixLines), function(postfix, index) {
    return _c('tr', {
      key: index
    }, [(postfix.isEdit) ? [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPostfix.content !== 'image') ? _c('v-text-field', {
      staticClass: "min-w",
      attrs: {
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPostfix.content),
        "label": _vm.$lang.labels.fontHeight,
        "min": "0",
        "type": "number",
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPostfix.fontHeight),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "fontHeight", $$v)
        },
        expression: "tempPostfix.fontHeight"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPostfix.content !== 'image') ? _c('v-select', {
      staticClass: "min-w",
      attrs: {
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPostfix.content),
        "items": _vm.fontStyles,
        "label": _vm.$lang.labels.fontStyle,
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPostfix.fontStyle),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "fontStyle", $$v)
        },
        expression: "tempPostfix.fontStyle"
      }
    }) : [_c('v-text-field', {
      ref: "fileTextField",
      refInFor: true,
      staticClass: "min-w",
      attrs: {
        "prepend-icon": "attach_file",
        "single-line": "",
        "hide-details": "",
        "label": "choose_file",
        "required": ""
      },
      on: {
        "click": function($event) {
          return _vm.startInput('postfixFileInput')
        }
      },
      model: {
        value: (_vm.tempPostfix.filename),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "filename", $$v)
        },
        expression: "tempPostfix.filename"
      }
    }), _vm._v(" "), _c('input', {
      ref: "postfixFileInput",
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange('tempPostfix', $event)
        }
      }
    })]], 2), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [_c('v-combobox', {
      staticClass: "min-w",
      attrs: {
        "label": _vm.$lang.labels.content,
        "items": _vm.lineChoices,
        "required": "",
        "search-input": _vm.tempPostfix.content,
        "hide-details": ""
      },
      on: {
        "update:searchInput": function($event) {
          return _vm.$set(_vm.tempPostfix, "content", $event)
        },
        "update:search-input": function($event) {
          return _vm.$set(_vm.tempPostfix, "content", $event)
        }
      },
      model: {
        value: (_vm.tempPostfix.content),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "content", $$v)
        },
        expression: "tempPostfix.content"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempPostfix.content ||
          (_vm.tempPostfix.content !== 'image' && (!_vm.tempPostfix.fontHeight || !_vm.tempPostfix.fontStyle)) ||
          (_vm.tempPostfix.content === 'image' && !_vm.tempPostfix.filename)
      },
      on: {
        "click": function($event) {
          return _vm.savePostfixEdit(postfix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closePostfixEdit(postfix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }, [(_vm.postfixLines.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.postfixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up")]) : _vm._e(), _vm._v(" "), (index != _vm.postfixLines.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.postfixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (postfix.content !== 'image') ? _c('td', [_vm._v(_vm._s(postfix.fontHeight))]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": postfix.content !== 'image' ? 1 : 2
      }
    }, [_vm._v(_vm._s(postfix.content !== 'image' ? postfix.fontStyle : postfix.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(postfix.content))]), _vm._v(" "), (!_vm.isView) ? _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": _vm.disablePostfixes
      },
      on: {
        "click": function($event) {
          return _vm.editingPostfix(postfix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deletePostfix(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1) : _vm._e()]], 2)
  }), 0)])]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0 mt-4",
    attrs: {
      "disabled": !_vm.previewValidation,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.preview) + "\n        ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2 mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isView && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isView && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'printTemplates'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), (!_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isClone ? _vm.$lang.actions.createCopy : _vm.$lang.actions.create) + "\n        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.previewModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.previewModal),
      callback: function($$v) {
        _vm.previewModal = $$v
      },
      expression: "previewModal"
    }
  }, [_c('preview', {
    attrs: {
      "data": _vm.previewData
    },
    on: {
      "close": function($event) {
        _vm.previewModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "390"
    },
    model: {
      value: (_vm.activationModal),
      callback: function($$v) {
        _vm.activationModal = $$v
      },
      expression: "activationModal"
    }
  }, [_c('activate', {
    on: {
      "activate": _vm.activate
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showImportModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "390"
    },
    model: {
      value: (_vm.showImportModal),
      callback: function($$v) {
        _vm.showImportModal = $$v
      },
      expression: "showImportModal"
    }
  }, [_c('import', {
    attrs: {
      "companies": _vm.companies,
      "types": _vm.types
    },
    on: {
      "submit": _vm.setTemplate,
      "close": function($event) {
        _vm.showImportModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a28c49f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/printTemplates/PrintTemplateDetails.vue
// module id = 400
// module chunks = 35